var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.92 14.6667C27.618 11.9628 26.4055 9.44205 24.4817 7.51825C22.5579 5.59446 20.0372 4.38201 17.3333 4.07999V1.33333H14.6667V4.07999C11.9628 4.38201 9.44205 5.59446 7.51825 7.51825C5.59446 9.44205 4.38201 11.9628 4.07999 14.6667H1.33333V17.3333H4.07999C4.38201 20.0372 5.59446 22.5579 7.51825 24.4817C9.44205 26.4055 11.9628 27.618 14.6667 27.92V30.6667H17.3333V27.92C20.0372 27.618 22.5579 26.4055 24.4817 24.4817C26.4055 22.5579 27.618 20.0372 27.92 17.3333H30.6667V14.6667H27.92ZM16 25.3333C10.84 25.3333 6.66666 21.16 6.66666 16C6.66666 10.84 10.84 6.66666 16 6.66666C21.16 6.66666 25.3333 10.84 25.3333 16C25.3333 21.16 21.16 25.3333 16 25.3333Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 10,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8f76d8e9254576382b8787516c92584d.svg";
export { ForwardRef as ReactComponent };